import { useParams } from 'react-router-dom';
import DashboardUserHeading from '../../atoms/dashboard-user-heading/DashboardUserHeading';
import { useSetAtom } from 'jotai';
import {
  personalDetailsDataAtom,
  portfolioSummaryDataAtom
} from 'stores/dashboard-store/dashboard-store';
import { useEffect } from 'react';
import { mockClientData } from 'stores/mockData';
import {
  NaturalPersonDetails,
  LegalEntityDetails
} from 'modules/dashboard/types/widgets/widget.interfaces';
import GridLayoutShell from '../../organisms/grid-layout/GridLayoutShell';
import { BreakpointProvider } from '../../../../../providers/breakpoint/BreakpointProvider';

export const ClientDashboard = () => {
  const { userId } = useParams();

  const setPersonalDetails = useSetAtom(personalDetailsDataAtom);
  const setPortfolioSummary = useSetAtom(portfolioSummaryDataAtom);
  const client = mockClientData.find((c) => c.id === Number(userId));

  useEffect(() => {
    const client = mockClientData.find((c) => c.id === Number(userId));
    if (client && client.personalDetails && client.portfolioSummary) {
      if (client.personalDetails.type === 'natural') {
        setPersonalDetails({
          type: 'natural',
          naturalPerson: client.personalDetails,
          legalEntity: {} as LegalEntityDetails
        });
      } else {
        setPersonalDetails({
          type: 'legal',
          naturalPerson: {} as NaturalPersonDetails,
          legalEntity: client.personalDetails
        });
      }
      setPortfolioSummary(client.portfolioSummary);
    }
  }, [userId, setPersonalDetails, setPortfolioSummary]);

  return (
    <BreakpointProvider>
      <div>
        <DashboardUserHeading
          type='client'
          user={
            client?.personalDetails?.type === 'natural'
              ? `${client.personalDetails.name} ${client.personalDetails.surname}`
              : (client?.personalDetails?.entityName ?? 'Unknown')
          }
        />
        <GridLayoutShell pageType='client' />
      </div>
    </BreakpointProvider>
  );
};
